/* eslint-disable no-shadow */
const enum UserRole {
  Administrator = 'Administrator',
  SalesManager = 'Sales_Manager',
  SalesUser = 'Sales_User',
  MarketingUser = 'Marketing_User',
}

export default UserRole;
